import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import { elo as theme } from '../../themes';
import Heading from '../Heading/Heading';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import iconList from '../Icon/iconList';
import { jsx as ___EmotionJSX } from "@emotion/core";
var renderAcronym = function renderAcronym(initials, size) {
  if (size === 'small') {
    return ___EmotionJSX(Text, {
      element: "span",
      size: "t4",
      bold: true,
      brand: true
    }, initials);
  }
  if (size === 'medium' || size === 'large') {
    return ___EmotionJSX(Heading, {
      element: "h2",
      bold: true,
      variant: "brand",
      noParagraph: true,
      textTransform: "uppercase"
    }, initials);
  }
  if (size === 'xLarge' || size === 'xxLarge') {
    return ___EmotionJSX(Heading, {
      element: "h2",
      highlight: true,
      bold: true,
      variant: "brand",
      noParagraph: true,
      text: true,
      textTransform: "uppercase"
    }, initials);
  }
  return ___EmotionJSX(Text, {
    size: "t4",
    element: "span",
    bold: true,
    brand: true,
    textTransform: "uppercase"
  }, initials);
};
var Avatar = function Avatar(_ref) {
  var icon = _ref.icon,
    name = _ref.name,
    size = _ref.size,
    src = _ref.src,
    dataTestId = _ref.dataTestId;
  var normalizedName = name == null ? void 0 : name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  var allInitials = (normalizedName == null ? void 0 : normalizedName.match(/\b\w/g)) || [];
  var initials = (allInitials.shift() || '').toUpperCase();
  if (src) {
    return ___EmotionJSX(AvatarStyle, {
      size: size,
      "data-test-id": dataTestId
    }, ___EmotionJSX("img", {
      alt: name,
      src: src
    }));
  }
  if (icon) {
    return ___EmotionJSX(AvatarStyle, {
      size: size,
      "data-test-id": dataTestId
    }, ___EmotionJSX(Icon, {
      type: icon,
      size: iconSize(size),
      color: theme.colors.purple40
    }));
  }
  return ___EmotionJSX(AvatarStyle, {
    size: size,
    "data-test-id": dataTestId
  }, renderAcronym(initials, size));
};
Avatar.propTypes = {
  icon: PropTypes.oneOf(Object.keys(iconList)),
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  src: PropTypes.string,
  dataTestId: PropTypes.string
};
var iconSize = function iconSize(size) {
  switch (size) {
    case 'small':
      return 'normal';
    case 'medium':
      return 'big';
    case 'large':
      return 'big';
    case 'xLarge':
      return 'large';
    case 'xxLarge':
      return 'xLarge';
    default:
      return 'normal';
  }
};
var avatarSize = function avatarSize(size) {
  switch (size) {
    case 'small':
      return '32px';
    case 'medium':
      return '64px';
    case 'large':
      return '80px';
    case 'xLarge':
      return '144px';
    case 'xxLarge':
      return '180px';
    default:
      return '32px';
  }
};
var AvatarStyle = _styled("div", {
  target: "edvpsme0"
})("display:flex;border-radius:", theme.shapes.shapes100, ";background-color:", theme.colors.purple10, ";justify-content:center;align-items:center;width:", function (props) {
  return avatarSize(props.size);
}, ";height:", function (props) {
  return avatarSize(props.size);
}, ";img{width:", function (props) {
  return avatarSize(props.size);
}, ";height:", function (props) {
  return avatarSize(props.size);
}, ";border-radius:", theme.shapes.shapes100, ";object-fit:cover;}@media ", theme.breakpoints.mobile, "{h2{font-size:", function (props) {
  return props.size === 'xLarge' || props.size === 'xxLarge' ? '52px' : '24px';
}, ";}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0F2YXRhci9BdmF0YXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdJOEIiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQXZhdGFyL0F2YXRhci5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IHsgZWxvIGFzIHRoZW1lIH0gZnJvbSAnLi4vLi4vdGhlbWVzJ1xuaW1wb3J0IEhlYWRpbmcgZnJvbSAnLi4vSGVhZGluZy9IZWFkaW5nJ1xuaW1wb3J0IEljb24gZnJvbSAnLi4vSWNvbi9JY29uJ1xuaW1wb3J0IFRleHQgZnJvbSAnLi4vVGV4dC9UZXh0J1xuaW1wb3J0IGljb25MaXN0IGZyb20gJy4uL0ljb24vaWNvbkxpc3QnXG5cbmNvbnN0IHJlbmRlckFjcm9ueW0gPSAoaW5pdGlhbHMsIHNpemUpID0+IHtcbiAgaWYgKHNpemUgPT09ICdzbWFsbCcpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPFRleHQgZWxlbWVudD0nc3Bhbicgc2l6ZT0ndDQnIGJvbGQgYnJhbmQ+XG4gICAgICAgIHtpbml0aWFsc31cbiAgICAgIDwvVGV4dD5cbiAgICApXG4gIH1cblxuICBpZiAoc2l6ZSA9PT0gJ21lZGl1bScgfHwgc2l6ZSA9PT0gJ2xhcmdlJykge1xuICAgIHJldHVybiAoXG4gICAgICA8SGVhZGluZ1xuICAgICAgICBlbGVtZW50PSdoMidcbiAgICAgICAgYm9sZFxuICAgICAgICB2YXJpYW50PSdicmFuZCdcbiAgICAgICAgbm9QYXJhZ3JhcGhcbiAgICAgICAgdGV4dFRyYW5zZm9ybT0ndXBwZXJjYXNlJ1xuICAgICAgPlxuICAgICAgICB7aW5pdGlhbHN9XG4gICAgICA8L0hlYWRpbmc+XG4gICAgKVxuICB9XG5cbiAgaWYgKHNpemUgPT09ICd4TGFyZ2UnIHx8IHNpemUgPT09ICd4eExhcmdlJykge1xuICAgIHJldHVybiAoXG4gICAgICA8SGVhZGluZ1xuICAgICAgICBlbGVtZW50PSdoMidcbiAgICAgICAgaGlnaGxpZ2h0XG4gICAgICAgIGJvbGRcbiAgICAgICAgdmFyaWFudD0nYnJhbmQnXG4gICAgICAgIG5vUGFyYWdyYXBoXG4gICAgICAgIHRleHRcbiAgICAgICAgdGV4dFRyYW5zZm9ybT0ndXBwZXJjYXNlJ1xuICAgICAgPlxuICAgICAgICB7aW5pdGlhbHN9XG4gICAgICA8L0hlYWRpbmc+XG4gICAgKVxuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8VGV4dCBzaXplPSd0NCcgZWxlbWVudD0nc3BhbicgYm9sZCBicmFuZCB0ZXh0VHJhbnNmb3JtPSd1cHBlcmNhc2UnPlxuICAgICAge2luaXRpYWxzfVxuICAgIDwvVGV4dD5cbiAgKVxufVxuXG5jb25zdCBBdmF0YXIgPSAoeyBpY29uLCBuYW1lLCBzaXplLCBzcmMsIGRhdGFUZXN0SWQgfSkgPT4ge1xuICBjb25zdCBub3JtYWxpemVkTmFtZSA9IG5hbWU/Lm5vcm1hbGl6ZSgnTkZEJykucmVwbGFjZSgvW1xcdTAzMDAtXFx1MDM2Zl0vZywgJycpXG4gIGNvbnN0IGFsbEluaXRpYWxzID0gbm9ybWFsaXplZE5hbWU/Lm1hdGNoKC9cXGJcXHcvZykgfHwgW11cbiAgY29uc3QgaW5pdGlhbHMgPSAoYWxsSW5pdGlhbHMuc2hpZnQoKSB8fCAnJykudG9VcHBlckNhc2UoKVxuXG4gIGlmIChzcmMpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPEF2YXRhclN0eWxlIHNpemU9e3NpemV9IGRhdGEtdGVzdC1pZD17ZGF0YVRlc3RJZH0+XG4gICAgICAgIDxpbWcgYWx0PXtuYW1lfSBzcmM9e3NyY30gLz5cbiAgICAgIDwvQXZhdGFyU3R5bGU+XG4gICAgKVxuICB9XG5cbiAgaWYgKGljb24pIHtcbiAgICByZXR1cm4gKFxuICAgICAgPEF2YXRhclN0eWxlIHNpemU9e3NpemV9IGRhdGEtdGVzdC1pZD17ZGF0YVRlc3RJZH0+XG4gICAgICAgIDxJY29uIHR5cGU9e2ljb259IHNpemU9e2ljb25TaXplKHNpemUpfSBjb2xvcj17dGhlbWUuY29sb3JzLnB1cnBsZTQwfSAvPlxuICAgICAgPC9BdmF0YXJTdHlsZT5cbiAgICApXG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxBdmF0YXJTdHlsZSBzaXplPXtzaXplfSBkYXRhLXRlc3QtaWQ9e2RhdGFUZXN0SWR9PlxuICAgICAge3JlbmRlckFjcm9ueW0oaW5pdGlhbHMsIHNpemUpfVxuICAgIDwvQXZhdGFyU3R5bGU+XG4gIClcbn1cblxuQXZhdGFyLnByb3BUeXBlcyA9IHtcbiAgaWNvbjogUHJvcFR5cGVzLm9uZU9mKE9iamVjdC5rZXlzKGljb25MaXN0KSksXG4gIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgc3JjOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBkYXRhVGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufVxuXG5jb25zdCBpY29uU2l6ZSA9IHNpemUgPT4ge1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzbWFsbCc6XG4gICAgICByZXR1cm4gJ25vcm1hbCdcblxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgICByZXR1cm4gJ2JpZydcblxuICAgIGNhc2UgJ2xhcmdlJzpcbiAgICAgIHJldHVybiAnYmlnJ1xuXG4gICAgY2FzZSAneExhcmdlJzpcbiAgICAgIHJldHVybiAnbGFyZ2UnXG5cbiAgICBjYXNlICd4eExhcmdlJzpcbiAgICAgIHJldHVybiAneExhcmdlJ1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiAnbm9ybWFsJ1xuICB9XG59XG5cbmNvbnN0IGF2YXRhclNpemUgPSBzaXplID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnc21hbGwnOlxuICAgICAgcmV0dXJuICczMnB4J1xuXG4gICAgY2FzZSAnbWVkaXVtJzpcbiAgICAgIHJldHVybiAnNjRweCdcblxuICAgIGNhc2UgJ2xhcmdlJzpcbiAgICAgIHJldHVybiAnODBweCdcblxuICAgIGNhc2UgJ3hMYXJnZSc6XG4gICAgICByZXR1cm4gJzE0NHB4J1xuXG4gICAgY2FzZSAneHhMYXJnZSc6XG4gICAgICByZXR1cm4gJzE4MHB4J1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiAnMzJweCdcbiAgfVxufVxuXG5jb25zdCBBdmF0YXJTdHlsZSA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGJvcmRlci1yYWRpdXM6ICR7dGhlbWUuc2hhcGVzLnNoYXBlczEwMH07XG4gIGJhY2tncm91bmQtY29sb3I6ICR7dGhlbWUuY29sb3JzLnB1cnBsZTEwfTtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHdpZHRoOiAke3Byb3BzID0+IGF2YXRhclNpemUocHJvcHMuc2l6ZSl9O1xuICBoZWlnaHQ6ICR7cHJvcHMgPT4gYXZhdGFyU2l6ZShwcm9wcy5zaXplKX07XG5cbiAgaW1nIHtcbiAgICB3aWR0aDogJHtwcm9wcyA9PiBhdmF0YXJTaXplKHByb3BzLnNpemUpfTtcbiAgICBoZWlnaHQ6ICR7cHJvcHMgPT4gYXZhdGFyU2l6ZShwcm9wcy5zaXplKX07XG4gICAgYm9yZGVyLXJhZGl1czogJHt0aGVtZS5zaGFwZXMuc2hhcGVzMTAwfTtcbiAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgfVxuXG4gIEBtZWRpYSAke3RoZW1lLmJyZWFrcG9pbnRzLm1vYmlsZX0ge1xuICAgIGgyIHtcbiAgICAgIGZvbnQtc2l6ZTogJHtwcm9wcyA9PlxuICAgICAgICBwcm9wcy5zaXplID09PSAneExhcmdlJyB8fCBwcm9wcy5zaXplID09PSAneHhMYXJnZScgPyAnNTJweCcgOiAnMjRweCd9O1xuICAgIH1cbiAgfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBBdmF0YXJcbiJdfQ== */"));
export default Avatar;